export const GITHUBTEXT = "github.com/nietzschemon";
export const LNTEXT = "linkedin.com/in/stefan-ekblom-2a5a99191/";
export const CODEWARSTEXT = "codewars.com/users/Logomon";
export const CVTEXT = "Hi there! My name is Stefan and I have been coding for 4 years." +
"\nTo see some of the stuff I have been working on visit my github" +
"";